declare let THREE: any;

const matrix = new THREE.Matrix4();
const wallBox = new THREE.Box3();
const objectBox = new THREE.Box3();
const objectBoxCenter = new THREE.Vector3();
const objectBoxSize = new THREE.Vector3();

/**
 *@description
 * Check if object within
 * wall boundary
 * @param {any} wall
 * @param {any} entity
 * @param {any} position
 * @param {any} rotation
 * @function
 */
export const wallContainsEmbeddedObject = (wall, entity, position, rotation): boolean => {
  if (!wall.geometry.boundingBox) wall.geometry.computeBoundingBox();

  wallBox.copy(wall.geometry.boundingBox);
  wallBox.applyMatrix4(wall.matrixWorld);

  matrix.identity();
  matrix.makeRotationFromEuler(rotation);
  matrix.setPosition(position);

  objectBoxSize.set(entity.length, entity.height, 1);
  objectBox.setFromCenterAndSize(objectBoxCenter, objectBoxSize);
  objectBox.applyMatrix4(matrix);

  return wallBox.containsBox(objectBox);
};



// WEBPACK FOOTER //
// ./src/app/services/wall/utils/wall-contains-embedded-object.ts